import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, CheckIcon } from 'lucide-react';
export function FinalCTA() {
  const trustItems = ['No-pressure estimates', '2-year / 24,000-mile warranty', '4.9 stars ·  595+ reviews'];
  return <section id="book" className="py-24 px-4 bg-[#C8B4A4] text-brand-dark relative overflow-hidden" data-id="element-83">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[#c8b4a4]" style={{
      backgroundImage: 'radial-gradient(#c8b4a4 2px, transparent 2px)',
      backgroundSize: '32px 32px'
    }} data-id="element-84"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          <span className="uppercase tracking-widest text-sm font-extrabold text-brand-dark/80 mb-4 block" data-id="element-87">
            Ready for a better alternative?
          </span>
          <h2 className="font-heading uppercase tracking-wide text-4xl md:text-5xl lg:text-6xl font-extrabold mb-8" data-id="element-88">
            Schedule your free diagnostic inspection
          </h2>
          <p className="text-xl md:text-2xl font-medium text-brand-dark/90 mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-89">
            Our ASE-certified technicians inspect your vehicle, identify the
            real cause of the issue, and show you exactly what we find before
            recommending any repairs.
          </p>
          <p className="text-lg md:text-xl font-medium text-brand-dark/80 mb-4 max-w-3xl mx-auto" data-id="element-90">
            If the dealership recommendation is correct, we'll tell you.
          </p>
          <p className="text-lg md:text-xl font-medium text-brand-dark/80 mb-12 max-w-3xl mx-auto" data-id="element-91">
            If there's a simpler solution, we'll show you.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-12" data-id="element-92">
            <a href="https://www.lancerservice.com/" className="w-full sm:w-auto px-10 py-5 bg-brand-dark hover:bg-gray-800 text-white text-lg font-bold rounded-md transition-colors shadow-2xl inline-flex justify-center items-center" data-id="element-93">
              Book Your Inspection Online
            </a>
            <a href="tel:6512240267" className="w-full sm:w-auto px-10 py-5 bg-transparent border-2 border-brand-dark hover:bg-brand-dark/10 text-brand-dark text-lg font-bold rounded-md transition-colors flex items-center justify-center gap-2" data-id="element-94">
              Call (651) 224-0267
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm md:text-base font-bold text-brand-dark/80" data-id="element-95">
            {trustItems.map((item, index) => <div key={index} className="flex items-center gap-1.5" data-id="element-96">
                <CheckIcon className="w-5 h-5" data-id="element-97" />
                <span data-id="element-98">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}